export enum RemoteConfigItem {
    MAINTENANCE_ACTIVE = 'MAINTENANCE_ACTIVE',
    MAINTENANCE_STARTTIME = 'MAINTENANCE_STARTTIME',
    MAINTENANCE_ENDTIME = 'MAINTENANCE_ENDTIME',
}